export default __webpack_public_path__ + "static/media/file-icon.bece0554.svg";